exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pie-container {\n  position: relative; }\n\n.centralise-element {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: inherit; }\n\n.pie-outer-layer {\n  height: 100%;\n  width: 50%;\n  border-radius: 50%;\n  box-shadow: 0 0 10px #575858;\n  border: 1px solid #7d7e7e; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/progress-chart/progress-chart.component.scss
// module id = ../../../../../src/app/core/components/progress-chart/progress-chart.component.scss
// module chunks = main